import * as genes from './genes';
import * as diseases from './diseases';
import * as variants from './variants';
import * as chemicals from './chemicals';
import * as aggregated from './aggregated';
import * as mappings from './mappings';

export const Views = {
  ...genes,
  ...diseases,
  ...variants,
  ...chemicals,
  ...aggregated,
  ...mappings,
};